module.exports = __webpack_public_path__ + "static/media/ayala-white.69c00e00.svg";